import React, { useState, useEffect } from "react";
import { FaFilter, FaSave, FaCheckCircle } from "react-icons/fa";
import { MdOutlinePeopleAlt } from "react-icons/md";
import { BsCalendar2Range } from "react-icons/bs";
const ShiftKaryawan = () => {
  const [periods, setPeriods] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [daysInMonth, setDaysInMonth] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [shiftOptions, setShiftOptions] = useState([]);
  const [outlets, setOutlets] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1); 
  const days = ["M", "S", "S", "R", "K", "J", "S"];
  const [showAddPeriod, setShowAddPeriod] = useState(false);
  const [newPeriodYear, setNewPeriodYear] = useState(year);
  const [newPeriodMonth, setNewPeriodMonth] = useState(month);
  useEffect(() => {
    fetchOutlets();
    fetchPeriods();
    fetchShiftOptions();
  }, []);
  useEffect(() => {
    if (selectedPeriod && selectedOutlet) {
      updateDaysInMonth(selectedPeriod.month, selectedPeriod.year);
      setShifts([]);
      setEmployees([]);
      fetchShifts(selectedPeriod.id, selectedOutlet);
    }
  }, [selectedPeriod, selectedOutlet]);
  useEffect(() => {
    if (selectedPeriod) {
      updateDaysInMonth(selectedPeriod.month, selectedPeriod.year);
    }
  }, [selectedPeriod]);
  const fetchOutlets = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/outlet?per_page=100&page=1&order_by=name`,
        { method: "GET", headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      const data = await response.json();
      setOutlets(data.data);
      const storedOutletId = localStorage.getItem("id_outlet");
      if (storedOutletId) {
        setSelectedOutlet(storedOutletId);
      } else if (data.data.length > 0) {
        setSelectedOutlet(data.data[0].id);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const fetchPeriods = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/shift/period-shift`,
        { method: "GET", headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      const data = await response.json();
      setPeriods(data.data);

      if (data.data.length > 0) {
        const today = new Date();
        const currentMonth = today.getMonth() + 1;
        const currentYear = today.getFullYear();
        const currentPeriod = data.data.find(
          (period) => period.month === currentMonth && period.year === currentYear
        );

        setSelectedPeriod(currentPeriod || data.data[0]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleAddPeriod = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/shift/period-shift`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            year: parseInt(newPeriodYear),
            month: parseInt(newPeriodMonth),
          }),
        }
      );
      const result = await response.json();
      if (result.success) {
        alert("Periode berhasil ditambahkan");
        setShowAddPeriod(false);
        fetchPeriods(); // refresh periode
      } else {
        alert("Gagal menambah periode: " + result.message);
      }
    } catch (error) {
      console.error("Error adding period:", error);
      alert("Terjadi kesalahan saat menambah periode");
    }
  };
  const fetchShiftOptions = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/shift?page&per_page&order_by&search`,
        { method: "GET", headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      const data = await response.json();
      setShiftOptions(data.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const fetchShifts = async (periodId, outletId) => {
    console.log(`Fetching shifts for Outlet ${outletId} and Period ${periodId}`);
    setShifts([]); // Kosongkan shifts sebelum fetch
    setEmployees([]); // Kosongkan employees sebelum fetch
  
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/employee/shift?outlet_id=${outletId}&period_id=${periodId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
  
      const shiftData = await response.json();
      console.log("✅ Response Data Shift:", shiftData);
  
      if (!shiftData.data || shiftData.data.length === 0) {
        console.log("⚠️ No shifts found.");
        setShifts([]);
        setEmployees([]);
        return;
      }
  
      // Buat daftar shift sesuai tanggal dalam periode (dari index 1)
      const formattedShifts = shiftData.data.map((employee) => {
        // Inisialisasi array kosong dengan panjang +1 agar index 1 sesuai dengan tanggal ke-1
        let employeeShifts = Array(daysInMonth.length + 1).fill("");
  
        // Masukkan shift ke index yang sesuai (dimulai dari index 1)
        employee.shifts.forEach(({ day, shift }) => {
          const date = new Date(day).getDate(); // Ambil tanggal (misal 1 - 31)
          employeeShifts[date] = shift.id; // Simpan shift.id di index sesuai tanggal
        });
  
        return {
          id: employee.id,
          full_name: employee.full_name,
          shifts: employeeShifts,
        };
      });
  
      setShifts(formattedShifts);
      setEmployees(
        formattedShifts.map((emp) => ({
          id: emp.id,
          full_name: emp.full_name,
        }))
      );
    } catch (error) {
      console.error("Error fetching shifts:", error);
    }
  };
  
  const updateDaysInMonth = (month, year) => {
    const today = new Date();
    const totalDays = new Date(year, month, 0).getDate();
  
    const daysArray = [];
  
    for (let i = 1; i <= totalDays + 1; i++) { // ← tambahkan +1
      const fullDate = new Date(year, month - 1, i);
      daysArray.push({
        date: i,
        day: fullDate.toLocaleDateString("id-ID", { weekday: "long" }),
        fullDate,
        isPast: fullDate < today,
      });
    }
  
    setDaysInMonth(daysArray);
  };  
  const handleSaveShifts = async () => {
    setSaving(true);
    const requestData = {
      period_id: selectedPeriod.id,
      employees: shifts.map((shift) => ({
        employee_id: shift.id,
        shifts: shift.shifts.map((shiftId, index) => {
          const shiftDate = daysInMonth[index]?.fullDate.toISOString().split("T")[0];
          return {
            shift_id: shiftId ? parseInt(shiftId, 10) : null,
            day: shiftDate,
          };
        })
          .filter((s) => {
            const shiftDate = new Date(s.day);
            return (
              s.shift_id !== null &&
              shiftDate.getFullYear() === selectedPeriod.year &&
              shiftDate.getMonth() + 1 === selectedPeriod.month
            );
          }), // Filter hanya shift dalam bulan yang dipilih
      })),
    };
    console.log(" Data Terkirim:", JSON.stringify(requestData, null, 2));
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/shift/process-batch-employee-shifting`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestData),
        }
      );
      const result = await response.json();
      console.log("Response:", result);
  
      if (result.success) {
        alert("Shifts berhasil disimpan!");
      } else {
        alert("Gagal menyimpan shift: " + result.message);
      }
  
    } catch (error) {
      console.error(" Error saving shifts:", error);
      alert("Terjadi kesalahan saat menyimpan shift.");
    } finally {
      setSaving(false);
    }
  };
  const handleShiftChange = (employeeId, dateIndex, newShift) => {
    setShifts((prevShifts) =>
      prevShifts.map((shift) =>
        shift.id === employeeId
          ? {
              ...shift,
              shifts: shift.shifts.map((s, index) =>
                index === dateIndex ? newShift : s
              ),
            }
          : shift
      )
    );
    setIsUpdated(true); // Tandai bahwa ada perubahan
  };
  return (
<div className="p-6 bg-gray-100 min-h-screen">
  <h1 className="text-3xl font-bold mb-6 text-gray-700 flex items-center gap-2">
    <MdOutlinePeopleAlt className="text-blue-500" /> Karyawan / Shifting
  </h1>
  <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-200">
    {/* Filter */}
    <div className="flex flex-col md:flex-row md:items-end gap-6 mb-6">
      <div className="flex flex-col">
        <label className="font-semibold text-sm mb-1 flex items-center gap-1 text-gray-600">
          <FaFilter className="text-gray-400" /> Outlet
        </label>
        <select
          value={selectedOutlet || ""}
          onChange={(e) => setSelectedOutlet(e.target.value)}
          className="border border-gray-300 rounded-xl px-3 py-2 text-sm"
        >
          {outlets.map((outlet) => (
            <option key={outlet.id} value={outlet.id}>
              {outlet.name}
            </option>
          ))}
        </select>
      </div>
      <div className="flex flex-col">
  <label className="font-semibold text-sm mb-1 flex items-center gap-1 text-gray-600">
    <BsCalendar2Range className="text-gray-400" /> Periode
  </label>
  <div className="flex gap-2 items-center">
    <select
      value={selectedPeriod?.id || ""}
      onChange={(e) =>
        setSelectedPeriod(periods.find((p) => p.id === parseInt(e.target.value)))
      }
      className="border border-gray-300 rounded-xl px-3 py-2 text-sm"
    >
      {periods.map((period) => (
        <option key={period.id} value={period.id}>
          {`${period.month}/${period.year}`}
        </option>
      ))}
    </select>
    <button
      type="button"
      onClick={() => setShowAddPeriod(!showAddPeriod)}
      className="bg-blue-500 text-white px-2.5 py-1.5 rounded-lg text-sm hover:bg-blue-600"
    >
      +
    </button>
  </div>
 {/* Form Tambah Periode */}
 {showAddPeriod && (
    <div className="mt-2 flex gap-2 items-center">
      <input
        type="number"
        value={newPeriodMonth}
        onChange={(e) => setNewPeriodMonth(e.target.value)}
        placeholder="Bulan"
        className="border border-gray-300 rounded-lg px-2 py-1 w-20 text-sm"
        min="1"
        max="12"
      />
      <input
        type="number"
        value={newPeriodYear}
        onChange={(e) => setNewPeriodYear(e.target.value)}
        placeholder="Tahun"
        className="border border-gray-300 rounded-lg px-2 py-1 w-24 text-sm"
        min="2000"
      />
      <button
        type="button"
        onClick={handleAddPeriod}
        className="bg-green-500 text-white px-3 py-1 rounded-lg text-sm hover:bg-green-600"
      >
        Simpan
      </button>
    </div>
  )}
</div>
    </div>
    {/* Table */}
    <div className="overflow-x-auto rounded-xl border border-gray-200">
      <table className="min-w-max w-full border-collapse text-sm">
        <thead>
          <tr className="bg-blue-100 text-gray-700 font-semibold">
           <th className="border border-gray-300 p-3">Nama</th>
{daysInMonth
  .filter(day => day.date >= 1 && day.date <= 31) // Filter hanya tanggal yang valid
  .map((day, index) => (
    <th key={index} className="border border-gray-300 p-2 whitespace-nowrap">
      <span className="block text-xs text-gray-500">{day.day}</span>
      <span className="text-sm">{day.date}</span>
    </th>
))}
  
          </tr>
        </thead>
        <tbody>
  {employees.length === 0 ? (
    <tr>
      <td colSpan={daysInMonth.length + 1} className="text-center p-4 text-gray-500">
        Tidak ada karyawan
      </td>
    </tr>
  ) : (
    employees.map((employee) => {
      const employeeShift = shifts.find((s) => s.id === employee.id);
      return (
        <tr key={employee.id} className="text-center bg-white even:bg-gray-50">
          <td className="border border-gray-300 p-2 font-medium text-left px-3">
            {employee.full_name}
          </td>
          {daysInMonth.slice(1).map((day, dateIndex) => (
            <td key={dateIndex} className="border border-gray-300 p-1">
              <select
                className="w-full text-xs p-1 border rounded"
                value={employeeShift?.shifts[dateIndex + 1] || ""}
                onChange={(e) =>
                  handleShiftChange(employee.id, dateIndex + 1, e.target.value)
                }
                disabled={day.isPast}
              >
                <option value="">-</option>
                {shiftOptions.map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.name}
                  </option>
                ))}
              </select>
            </td>
          ))}
        </tr>
      );
    })
  )}
</tbody>
      </table>
    </div>
    {/* Save Button.js */}
    <div className="mt-6 text-right">
      <button
        onClick={handleSaveShifts}
        className={`inline-flex items-center gap-2 px-5 py-2 rounded-xl text-white shadow-md transition duration-200 ${
          isUpdated
            ? "bg-green-500 hover:bg-green-600"
            : "bg-blue-500 hover:bg-blue-600"
        }`}
        disabled={saving}
      >
        {saving ? (
          <>
            <FaSave className="animate-spin" /> Menyimpan...
          </>
        ) : isUpdated ? (
          <>
            <FaCheckCircle /> Update
          </>
        ) : (
          <>
            <FaSave /> Simpan
          </>
        )}
      </button>
    </div>
  </div>
</div>
  );
};
export default ShiftKaryawan;
